import React, { FC } from "react";
import { Control, useController } from "react-hook-form";

import RadioBase, { RadioBaseProps } from "@/components/ui/Form/Filters/components/Radio/RadioBase";

export interface RadioControlledProps extends RadioBaseProps {
  control: Control;
}
const RadioControlled: FC<RadioControlledProps> = ({ control, ...rest }) => {
  const { name } = rest;
  const { field, fieldState } = useController({ control, name });
  return <RadioBase field={field} fieldState={fieldState} {...rest} />;
};
export default RadioControlled;
